import { formatWeekRange } from "./timecard";

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const DAYS_PER_WEEK = 7;

function getTimecardId(timecard) {
  return Number(timecard?.timecardId ?? timecard?.TimecardId ?? 0);
}

function getTimecardStatus(timecard) {
  return String(timecard?.status ?? timecard?.Status ?? "draft").toLowerCase();
}

function getWeekStartDate(timecard) {
  return timecard?.weekStartDate ?? timecard?.WeekStartDate ?? "";
}

function getWeekEndDate(timecard) {
  return timecard?.weekEndDate ?? timecard?.WeekEndDate ?? "";
}

function parseLocalDate(value) {
  const match = String(value ?? "").trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return null;
  }

  const parsed = new Date(
    Number.parseInt(match[1], 10),
    Number.parseInt(match[2], 10) - 1,
    Number.parseInt(match[3], 10)
  );

  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getWeekOffsetForStartDate(weekStartDate, baseWeekStartDate) {
  const weekStart = parseLocalDate(weekStartDate);
  const baseWeekStart = parseLocalDate(baseWeekStartDate);

  if (!weekStart || !baseWeekStart) {
    return 0;
  }

  return Math.round((weekStart.getTime() - baseWeekStart.getTime()) / (MS_PER_DAY * DAYS_PER_WEEK));
}

export function buildDraftTimecardChoices(timecards, baseWeekStartDate) {
  return (Array.isArray(timecards) ? timecards : [])
    .map((timecard) => {
      const weekStartDate = getWeekStartDate(timecard);
      const weekEndDate = getWeekEndDate(timecard);
      const parsedWeekStart = parseLocalDate(weekStartDate);
      const timecardId = getTimecardId(timecard);

      return {
        timecardId,
        weekStartDate,
        weekEndDate,
        status: getTimecardStatus(timecard),
        weekRange: parsedWeekStart ? formatWeekRange(parsedWeekStart) : "",
        weekOffset: getWeekOffsetForStartDate(weekStartDate, baseWeekStartDate),
        isCurrentWeek: weekStartDate === baseWeekStartDate
      };
    })
    .filter((choice) => choice.timecardId > 0 && choice.status === "draft" && choice.weekStartDate)
    .sort((left, right) => right.weekStartDate.localeCompare(left.weekStartDate));
}

export function isReadyToSubmitSelectedDraft(selectedTimecardId, draftSubmitReviewId, currentStatus) {
  return (
    Number(selectedTimecardId) > 0 &&
    Number(selectedTimecardId) === Number(draftSubmitReviewId) &&
    String(currentStatus ?? "draft").toLowerCase() === "draft"
  );
}

export function getApprovalSubmitLabel(status, submitLabel = "Submit timecard") {
  const normalizedStatus = String(status ?? "draft").toLowerCase();
  return normalizedStatus === "submitted" || normalizedStatus === "approved"
    ? "Resubmit timecard"
    : submitLabel;
}
